module.exports = __webpack_public_path__ + "static/media/unite.f5d82652.svg";